import React from "react";
import Label from "../atoms/Label";
import LinkBlock from "../organisms/LinkBlock";
import ReadMore from "../molecules/ReadMore";

export default ({ label, title, linkBlock, readMoreLink }) =>
    <section className="u-section-spacing u-container">
        <Label text={ label }/>
        { title && <h2>{ title }</h2> }
        <div className="m-column-grid">
            {
                linkBlock.map(({ title, link }, index) =>
                    <LinkBlock title={ title } links={ link } key={ index } />
                )
            }
        </div>
        { readMoreLink && <ReadMore link={ readMoreLink } text={ readMoreLink.title }/> }
    </section>;
